import { Component, OnInit } from '@angular/core';
import { Error } from 'src/app/shared/components/error/error.model';
import { MAX_WIDTH_MOBILE } from 'src/app/shared/data/biometrics.constants';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-camera-error',
  templateUrl: './camera-error.component.html',
  styleUrls: ['./camera-error.component.scss']
})
export class CameraErrorComponent implements OnInit {
  assetsUrl = environment.assetsUrl;
  public config: Error = {
    route: this.assetsUrl + '/images/cdt/icons/no-identity.svg',
    image: 'close-icon',
    width: '80px',
    title: 'No hemos detectado tu cámara',
    content:
      'Revisa que no la estés usando en otra aplicación y/o que hayas dado los permisos para acceder en tu navegador. <br /> <br /> Si no cuentas con una, puedes iniciar tu solicitud desde el celular.',
    link: {
      url: '/',
      text: 'Entendido'
    }
  };

  ngOnInit(): void {
    if (window.innerWidth <= MAX_WIDTH_MOBILE) {
      this.config.content =
        'Revisa que no la estés usando en otra aplicación y/o que hayas dado los permisos para acceder en tu navegador. <br /> <br /> Si no cuentas con una, puedes iniciar tu solicitud desde otro dispositivo móvil.';
    }
  }
}
